_collow.components.AdminEditUsers = class AdminEditUsers extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.getAndFillUserInfo();
    this.listen(document, "_collow-errorbox-active", this.errorboxActive);
  }

  getAndFillUserInfo = () => {
    const url = new URL(window.location);
    this.id = url.searchParams.get("id");

    fetch(this.params.path + "/admin/user/" + this.id, {
      method: "get",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        const resJson = await res.json();
        if (!res.ok) throw resJson;
        this.root.firstname.value = resJson.firstname;
        this.root.lastname.value = resJson.lastname;
        this.root.prefix.value = resJson.prefix;
        this.listen(this.root, "change", this.enableSave);
      })
      .catch((err) => this.dispatch(this.root, "_collow-custom-error", err));
  };

  enableSave = () => {
    this.unlisten(this.root, "change", this.enableSave);
    this.elements.submit.removeAttribute("data-disabled");
    this.listen(this.root, "submit", this.saveChanges);
  };

  saveChanges = (e) => {
    e.preventDefault();
    const formData = new FormData(this.root);

    fetch(this.params.path + "/admin/user/" + this.id, {
      method: "put",
      body: formData,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        const resJson = await res.json();
        if (!res.ok) throw resJson;
        this.root.firstname.value = resJson.firstname;
        this.root.lastname.value = resJson.lastname;
        this.root.prefix.value = resJson.prefix;
        this.elements.succes.removeAttribute("hidden");
        this.listen(this.root, "change", this.hideSucces);
      })
      .catch((err) => this.dispatch(this.root, "_collow-custom-error", err));
  };

  hideSucces = () => {
    this.elements.succes.setAttribute("hidden", "");
    this.unlisten(this.root, "change", this.hideSucces);
  };
};
